import React from 'react';
import firebase from "../config/firebase";
import CssBaseline from '@material-ui/core/CssBaseline';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { makeStyles , useTheme} from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Zoom from '@material-ui/core/Zoom';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DateRangeIcon from '@material-ui/icons/DateRange';
import Moment from 'react-moment';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import CircularProgress from '@material-ui/core/CircularProgress';
import { List, ListItem, Divider, Grid, Drawer, Button,
         Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions
   } from '@material-ui/core';

import Day from './Day.js';
import SidebarNav from './Sidebar.js';
import TurnForm from './TurnForm.js';
import { AuthContext } from '../Auth.js'


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
    flexGrow: 1,
    margin:theme.spacing(0),
    padding:theme.spacing(0),
    },
    title: {
    flexGrow: 1,
    textAlign:'left'
    }, 
    button: {
        margin: theme.spacing(1),
        float: 'right'
    },
    buttonX: {
      margin: theme.spacing(1),
    },
    celularAlert : {
      padding:theme.spacing(1),
      justify:"left",
      color  :"#CC0000" 
    },
    formularioAlert : {
      padding:theme.spacing(1),
      justify:"left",
      color  :"#CCDD00" 
    },
    imgLogo: {
      width: "50px",
      marginRight: theme.spacing(1)
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginRight: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(0),
      marginTop: theme.spacing(1),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: 0,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    nav: {
      marginBottom: theme.spacing(2)
    }
 }));

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}
  



function Schedule (props) {
    
    const classes = useStyles();
    const theme = useTheme();

    const [preferencias, setPreferencias] = React.useState(null);
    const [turnoVol, setTurnoVol] = React.useState(null);
    const [dias, setDias] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [newDayDate, setNewDayDate] = React.useState(null);
    const [openNewDay, setOpenNewDay] = React.useState(false);
    const [verPorSemana, setVerPorSemana] = React.useState(true);
    const {userProfile, currentUser} = React.useContext(AuthContext);
    
    var now = new Date();
    now.setHours(0,0,0,0);
    var auxNow = new Date(now)
    var auxEnd = new Date(now)
    auxEnd.setDate(auxEnd.getDate()+7)
    const [filterDateStart, setFilterDateStart] = React.useState(auxNow);
    const [filterDateEnd, setFilterDateEnd] = React.useState(auxEnd);

    const handleVerPorSemana = () => {
      setVerPorSemana(true);
      var now = new Date();
      now.setHours(0,0,0,0);
      var auxNow = new Date(now)
      var auxEnd = new Date(now)
      auxEnd.setDate(auxEnd.getDate()+7)
      
      setFilterDateStart(auxNow)
      setFilterDateEnd(auxEnd)
  
    }

    const handleVerPorMes = () => {
      setVerPorSemana(false);
      var now = new Date();
      now.setHours(0,0,0,0);
      var auxNow = new Date(now)
      var auxEnd = new Date(now)
      auxEnd.setDate(auxEnd.getDate()+30)
      setFilterDateStart(auxNow)
      setFilterDateEnd(auxEnd)
    }

    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(false);
    };

    const GetBase = () => {
    
      return (
      <>
        <CssBaseline />
        <AppBar position="sticky" color="default" 
          className={clsx(classes.appBar, {[classes.appBarShift]: open, })}
        >
        <Toolbar id="back-to-top-anchor" >
          <img alt="Unidos Para Ayudar" className={classes.imgLogo} src={require('../assets/img/logo.png')} />
          <Typography className={classes.title} variant="h6">Unidos para Ayudar</Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="right"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <SidebarNav 
          className={classes.nav} 
          />
        </Drawer>
      </>
      );
    };

    const handleNextDate = () => {
      var auxNow = new Date()
      auxNow.setTime(filterDateStart.getTime()+(7* 24 * 60 * 60 * 1000))
      auxNow.setHours(0,0,0,0)
      var auxEnd = new Date()
      auxEnd.setTime(filterDateEnd.getTime()+(7* 24 * 60 * 60 * 1000))
      auxEnd.setHours(0,0,0,0)
      setFilterDateStart(auxNow)
      setFilterDateEnd(auxEnd)
    }

    const handleBackDate = () => {
      var auxNow = new Date()
      auxNow.setTime(filterDateStart.getTime()-(7* 24 * 60 * 60 * 1000))
      auxNow.setHours(0,0,0,0)
      var auxEnd = new Date()
      auxEnd.setTime(filterDateEnd.getTime()-(7* 24 * 60 * 60 * 1000))
      auxEnd.setHours(0,0,0,0)
      setFilterDateStart(auxNow)
      setFilterDateEnd(auxEnd)
    }

    const verFiltroSemana = () => {
      if (!verPorSemana) 
        return (
          <>
          <Grid container alignItems="center" justify="center">
            <Grid item>
              Desde <Moment format="DD/MM">{filterDateStart}</Moment> a <Moment format="DD/MM">{filterDateEnd}</Moment>
            </Grid>
          </Grid>
          </>
        )
      return (
        <>
        <Grid container alignItems="center" justify="center">
            <Grid item>
            <IconButton
                onClick={handleBackDate}
                aria-label="semana anterior"
              >
                <KeyboardArrowLeft />
              </IconButton>
            </Grid>
            <Grid item>
              Desde <Moment format="DD/MM">{filterDateStart}</Moment> a <Moment format="DD/MM">{filterDateEnd}</Moment>
            </Grid>
            <Grid item>
            <IconButton
                onClick={handleNextDate}
                aria-label="semana anterior"
              >
                <KeyboardArrowRight />
              </IconButton>
            </Grid>
          </Grid>
        </>
      )
    }
  
    
    const handleNewDayOpen = () => {
      setOpenNewDay(true);
    };
  
    const handleNewDayClose = () => {
      setOpenNewDay(false);
    };

    
    const handleNewDayConfirm = () => {
      var fecha  = firebase.firestore.Timestamp.fromDate(new Date(newDayDate + "T00:00:00"))
      var diaRef = firebase.firestore().collection('orgs').doc('unidos').collection('dias').doc();
      var turnosRef1 = diaRef.collection('turnos').doc("1");
      var turnosRef2 = diaRef.collection('turnos').doc("2");
      var turnosRef3 = diaRef.collection('turnos').doc("3");
      var orgRef     = firebase.firestore().collection('orgs').doc('unidos')
      var dia = {
          'fecha'   : fecha,
          'created' : firebase.firestore.FieldValue.serverTimestamp(),
          'userId'  : currentUser.uid
      }
      return firebase.firestore().runTransaction(function(transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(orgRef).then(function(orgRef) {
              if (orgRef.exists) {
                  transaction.set(diaRef, dia);
                  transaction.set(turnosRef1, orgRef.data().turno1);
                  transaction.set(turnosRef2, orgRef.data().turno2);
                  transaction.set(turnosRef3, orgRef.data().turno3);
              }
              setOpenNewDay(false);
              // alert("Refresca la pagina para ver el nuevo dia")
              })
      }).then(function() {
      }).catch(function(error) {
          console.log("Transaction failed: ", error);
      });
    }
    
    const handleNewDayChange = (event) => {
      setNewDayDate(event.target.value);
    };

    const NewDay = () => {

      if (!userProfile)
        return;
      let organizador;
      if (typeof userProfile.organizador === "undefined") {
         return ;
      } else {
          organizador = userProfile.organizador;
      }
      if (!organizador) {
        return ;
      } else {
        return (
          <>
            <Button className={classes.buttonX} color="secondary" size="small" onClick={handleNewDayOpen}>
              <AddCircleIcon />
            </Button>
            <Dialog open={openNewDay} onClose={handleNewDayClose} aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">Agregar nuevo dia</DialogTitle>
              <DialogContent>
                <DialogContentText>
                <form className={classes.container} noValidate>
                  <TextField
                    id="date"
                    label="Nueva jornada"
                    type="date"
                    defaultValue={newDayDate}
                    className={classes.textField}
                    onChange={handleNewDayChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </form>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleNewDayClose} color="primary">
                  Cancelar
                </Button>
                <Button onClick={handleNewDayConfirm} color="primary">
                  Confirmar
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )
      }
    }

    const showAlertCelular = () => {
      if (!userProfile.celular || userProfile.celular === "" || userProfile.celular.length !== 12) {
        return (
          <ListItem className={classes.celularAlert}>
          Para poder registrarte a turnos deberás ingresar correctamente tu celular con formato internacional (+5989xxxxxxx) y con tu cédula de identidad correcta
          </ListItem>
        )
      }
    }
    
    React.useEffect(() => {
      const fetchDataPreferencias = () => {
        const db = firebase.firestore().collection('orgs').doc('unidos');
        db.get()
        .then(function(doc) {
            if (doc.exists) {
                setPreferencias({...doc.data()});
            } else {
                console.log("no existen la organizacion")
            }
        });
      }
      fetchDataPreferencias();
    }, []);

    React.useEffect(() => {
      const listenProximoTurno = () => {

        var now = new Date();
        now.setHours(0,0,0,0);
        var auxNow = new Date(now);

        const db = firebase.firestore().collection('orgs').doc('unidos');
        db.collection('users')
                .doc(currentUser.uid)
                .collection('turnos')
                .where("fecha", ">=", auxNow)
                .orderBy("fecha", "asc")
                .limit(1)
                .onSnapshot((snapshot)=> {
                    setTurnoVol(null) ;
                    snapshot.docs.forEach(function(doc) {
                      setTurnoVol({...doc.data(), id:doc.id});
                    });
                } , (error) => console.error(error));

      }
      listenProximoTurno();
    }, [currentUser.uid]);
    
    React.useEffect(() => {
      setDias(null)
      const fetchDataSimple = async () => {
      const db = firebase.firestore().collection('orgs').doc('unidos');
      const data = await db.collection("dias")
              .where("fecha", ">=", filterDateStart)
              .where("fecha", "<=", filterDateEnd)
              .get();
        setDias(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
      };  
      
      fetchDataSimple();
    }, [filterDateEnd, filterDateStart, openNewDay]);
 
    if (!preferencias) {
      return (
        <div className={classes.root}>
        { GetBase() }
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
        >
          <List>
            <ListItem>
              <CircularProgress />
            </ListItem>
          </List>
          </main>
        </div>
      )
    }
     
    if (!dias)  {
        return (
            <div className={classes.root}>
            { GetBase() }
            <main
              className={clsx(classes.content, {
                [classes.contentShift]: open,
              })}
            >
             <Toolbar id="calendar" >
            <Grid container direction="row"  alignItems="center" justify="flex-start">
            <Grid item xs={12}>
              { NewDay() } 
            </Grid>
            <Grid item xs={12}>
              <Button  
                  variant="contained"
                  color={ verPorSemana ? "primary" : "default" }
                  className={classes.buttonX}
                  startIcon={<CalendarTodayIcon />}
                  onClick={handleVerPorMes}
                  >
                Completo
              </Button>
              <Button  
                  variant="contained"
                  color={ verPorSemana ? "default" : "primary" }
                  className={classes.buttonX}
                  startIcon={<DateRangeIcon />}
                  onClick={handleVerPorSemana}
                  >
                    Semana         
                </Button>
            </Grid>
            <Grid item  xs={12}>
              { verFiltroSemana() }
            </Grid>
          </Grid>
        </Toolbar>
        <List>
          <ListItem>
          <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
              <Grid item xs={3}>
                    Días 
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid item xs>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                  <Grid xs item>
                       Horario
                  </Grid>
                  <Grid xs item>
                    Si / No
                  </Grid>
                  <Grid xs item>
                    Voluntarios
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          </ListItem>
          <Divider />
          <ListItem>
            <CircularProgress />
          </ListItem>
          </List>
          </main>
            </div>
            
        )
    } 

    if (!userProfile) { 
      return (
        <div className={classes.root}>
        { GetBase() }
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
        >
         <Toolbar id="calendar" >
          <Grid container direction="row"  alignItems="center" justify="flex-start">
            <Grid item xs={12}>
              { NewDay() } 
            </Grid>
            <Grid item xs={12}>
              <Button  
                  variant="contained"
                  color={ verPorSemana ? "primary" : "default" }
                  className={classes.buttonX}
                  startIcon={<CalendarTodayIcon />}
                  onClick={handleVerPorMes}
                  >
                Completo
              </Button>
              <Button  
                  variant="contained"
                  color={ verPorSemana ? "default" : "primary" }
                  className={classes.buttonX}
                  startIcon={<DateRangeIcon />}
                  onClick={handleVerPorSemana}
                  >
                    Semana         
                </Button>
            </Grid>
            <Grid item  xs={12}>
              { verFiltroSemana() }
            </Grid>
          </Grid>
        </Toolbar>
        <List>
          <ListItem>
          <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
              <Grid item xs={3}>
                    Días 
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid item xs>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                  <Grid xs item>
                       Horario
                  </Grid>
                  <Grid xs item>
                    Si / No
                  </Grid>
                  <Grid xs item>
                    Voluntarios
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          </ListItem>
          <Divider />
          <ListItem>
            <CircularProgress />
          </ListItem>
          </List>
          </main>
        </div>
      )
    }

    

    if (!dias.length) {
      return (
          <div className={classes.root}>
          { GetBase() }
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
          <Toolbar id="calendar" >
        <Grid container direction="row"  alignItems="center" justify="flex-start">
          <Grid item xs={12}>
            { NewDay() } 
          </Grid>
          <Grid item xs={12}>
            <Button  
                variant="contained"
                color={ verPorSemana ? "primary" : "default" }
                className={classes.buttonX}
                startIcon={<CalendarTodayIcon />}
                onClick={handleVerPorMes}
                >
              Completo
            </Button>
            <Button  
                variant="contained"
                color={ verPorSemana ? "default" : "primary" }
                className={classes.buttonX}
                startIcon={<DateRangeIcon />}
                onClick={handleVerPorSemana}
                >
                  Semana         
              </Button>
          </Grid>
          <Grid item  xs={12}>
            { verFiltroSemana() }
          </Grid>
        </Grid>
      </Toolbar>
      <List>
        <ListItem>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
            <Grid item xs={3}>
                  Días 
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item xs>
              <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                <Grid xs item>
                     Horario
                </Grid>
                <Grid xs item>
                  Si / No
                </Grid>
                <Grid xs item>
                  Voluntarios
                </Grid>
              </Grid>
            </Grid>
        </Grid>
        </ListItem>
        <Divider />
        { showAlertCelular() }
        <ListItem>
          <span>No hay turnos para estas fechas</span>
          </ListItem>
        </List>
        </main>
        </div>
      )
    }

    if (preferencias.verificacion.habilitada) {
      var today = new Date();
      if (turnoVol) {
        var diffMs = (turnoVol.fecha.toDate() - today);
        if (diffMs < preferencias.verificacion.tiempo) {
          if (!turnoVol.verificado)
            return (
              <div className={classes.root}>
                { GetBase() }
                <main
                      className={clsx(classes.content, {
                        [classes.contentShift]: open,
                      })}
                    >
                  <TurnForm turnoVol={turnoVol}/>
                </main>
              </div>
            )
          }
        }
    }

    return (
        <div className={classes.root}>
        { GetBase() }
        <main
              className={clsx(classes.content, {
                [classes.contentShift]: open,
              })}
            >
        <Toolbar id="calendar" >
          <Grid container direction="row"  alignItems="center" justify="center">
          <Grid item xs={12}>
              { NewDay() } 
            </Grid>
            <Grid item xs={12}>
            <Button  
                  variant="contained"
                  color={ verPorSemana ? "primary" : "default" }
                  className={classes.buttonX}
                  startIcon={<CalendarTodayIcon />}
                  onClick={handleVerPorMes}
                  >
                Completo
              </Button>
              <Button  
                  variant="contained"
                  color={ verPorSemana ? "default" : "primary" }
                  className={classes.buttonX}
                  startIcon={<DateRangeIcon />}
                  onClick={handleVerPorSemana}
                  >
                    Semana         
                </Button>
            </Grid>
            <Grid item  xs={12}>
              { verFiltroSemana() }
            </Grid>
          </Grid>
        </Toolbar>
        <List>
          <ListItem>
          <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
              <Grid item xs={3}>
                    Días 
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid item xs>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                  <Grid xs item>
                       Horario
                  </Grid>
                  <Grid xs item>
                    Si / No
                  </Grid>
                  <Grid xs item>
                    Voluntarios
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          </ListItem>
          <Divider />
          { showAlertCelular() }
          {
              Object.keys(dias).map(
              (key, id ) => (
                  <div key={id}>
                      <ListItem>
                        <Day dayInfo={dias[id]} />
                      </ListItem>
                      <Divider />
                  </div>
                  )
              )
          }
        </List>
        <ScrollTop {...props}>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
        </ScrollTop>
        </main> 
        </div>
    );

}

export default Schedule;